<div class="tab-content profile-edit-contact">
  <div class="bg-white">
    <mat-card class="card-container">
      <mat-card-header>
        <mat-card-title>Edit Your Contact Information</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <form [formGroup]="accountFrmGrp" (ngSubmit)="updateAccount()">
          <div class="profile-detail-form-field flex-input-col pt-2 pb-2">
            <mat-form-field>
              <input matInput placeholder="First name" formControlName="firstName" autocomplete="off" required>
              <mat-error>{{getDemographicErrorMessage("firstName")}}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Middle name" formControlName="middleName" autocomplete="off">
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Last name" formControlName="lastName" autocomplete="off" required>
              <mat-error>{{getDemographicErrorMessage("lastName")}}</mat-error>
            </mat-form-field>
          </div>
          <div class="profile-detail-form-field flex-input-col pt-2 pb-2">
            <mat-form-field>
              <input matInput placeholder="Address" formControlName="address1" autocomplete="off" required>
              <mat-error>{{getDemographicErrorMessage("address1")}}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Line 2" formControlName="address2" autocomplete="off">
            </mat-form-field>
          </div>
          <div class="profile-detail-form-field flex-input-col pt-2 pb-2">
            <mat-form-field>
              <input matInput placeholder="City" formControlName="city" autocomplete="off" required>
              <mat-error>{{getDemographicErrorMessage("city")}}</mat-error>
            </mat-form-field>
            <mat-form-field>
              <mat-select matInput disableOptionCentering panelClass="matSelectClass"
                [placeholder]="this.accountFrmGrp.get('country')!.value.trim() === 'CA' ? 'Province' : 'State'"
                formControlName="state" required>
                <mat-option *ngFor="let state of states" [value]="state.code">
                  {{state.name}}
                </mat-option>
              </mat-select>
              <mat-error>Required</mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Zip" formControlName="zip5" autocomplete="off" required>
              <mat-error>{{getDemographicErrorMessage("zip5")}}</mat-error>
            </mat-form-field>
          </div>
          <div class="profile-detail-form-field flex-input-col pt-2 pb-2">
            <mat-form-field>
              <mat-select matInput disableOptionCentering panelClass="matSelectClass" placeholder="Country"
                formControlName="country" required>
                <mat-option *ngFor="let country of countries" [value]="country.country">
                  {{country.countryName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="profile-detail-form-field flex-input-col pt-2 pb-2">
            <mat-form-field formGroupName="phoneGp">
              <!-- <input matInput placeholder="Phone" [mask]="phoneMask" formControlName="phoneNumber" required> -->
              <input matInput placeholder="Phone" formControlName="phoneNumber" [mask]="phoneMask" required>
              <span matPrefix>+{{accountFrmGrp.get('phoneGp.countryCode')?.value}}&nbsp;&nbsp;</span>
              <mat-hint>Ex. {{phoneExample}}</mat-hint>
              <mat-error *ngIf="!accountFrmGrp.get('phoneGp.isValid')?.value">Invalid Format</mat-error>
              <mat-error *ngIf="accountFrmGrp.get('phoneGp.phoneNumber')?.hasError('required')">Required</mat-error>
            </mat-form-field>
            <mat-form-field>
              <input matInput placeholder="Phone Ext" formControlName="phoneExt" autocomplete="off">
            </mat-form-field>
          </div>
          <div class="profile-detail-form-field flex-input-col pt-2 pb-2">
            <mat-form-field>
              <input matInput placeholder="Email" formControlName="email" autocomplete="off" required>
              <mat-hint *ngIf="isValidEmail && !isCheckingEmail" class="mat-hint-success">{{emailSuccessMessage}}
              </mat-hint>
              <span *ngIf="isCheckingEmail" matSuffix><i class="fa fa-refresh fa-spin fa-3x fa-fw"></i></span>
              <span *ngIf="isValidEmail" matSuffix><i class="fa fa-check"
                  style="font-size: 25px;color:darkgreen"></i></span>
              <mat-error>{{emailErrorMessage}}</mat-error>
            </mat-form-field>
          </div>
          <div class="flex-btn-row pt-2 pb-2">
            <button class="btn btn-secondary" mat-raised-button (click)="goBackInBrowser()">Cancel</button>
            <button class="btn btn-submit" mat-raised-button type="submit"
              [disabled]="accountFrmGrp.invalid">Save</button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div>
</div>